module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_payment.2466b45b.svg";